import React from "react";

import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import BracketDesk from "../../components/Brackets/BracketDesk";
import { useTournamentAuth } from "../../utils/authorization";
import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

export default function TournamentBrackets() {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();
  const { canManage, canEnterScores } = useTournamentAuth(tournamentId);

  return (
    <div className="space-y-6">
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0 print:hidden">
        <Breadcrumb
          items={[
            { label: "Home", path: "/" },
            { label: "Tournaments", path: "/tournaments" },
            {
              label: "Tournament",
              path: tournamentPath(tournamentSlug),
            },
            { label: "Brackets" },
          ]}
        />
      </div>

      <div className="card-board overflow-hidden print:border-0 print:shadow-none">
        <div className="bg-brand-charcoal text-brand-cream px-6 py-4 print:hidden">
          <h1 className="font-display font-bold text-xl text-brand-cream tracking-tight">
            Brackets
          </h1>
          <p className="text-sm text-brand-mist mt-1">
            {canEnterScores
              ? "Sell tickets, shuffle trees, and see who to pay."
              : "Trees, tickets, and who to pay."}
          </p>
        </div>
        <div className="p-4 sm:p-6">
          <BracketDesk
            tournamentId={tournamentId}
            canManage={canManage}
            canEnterScores={canEnterScores}
          />
        </div>
      </div>
    </div>
  );
}
